export const DEFAULT_ESTATE_BASE_DOMAIN = "innerreality-dev.viviewer.com";

export interface InitialCampaignSource {
	campaignId: string | null;
	subdomain: string | null;
	host?: string | null;
}

interface CampaignIdentifierOptions {
	campaignId: string | null;
	subdomain: string | null;
	hostname: string;
	estateBaseDomain?: string;
}

const normalizeDomain = (domain: string | null | undefined): string => {
	return (domain || "").trim().toLowerCase().replace(/\.$/, "");
};

export const getEstateBaseDomain = (
	configuredBaseDomain: string | undefined
): string => {
	return normalizeDomain(configuredBaseDomain) || DEFAULT_ESTATE_BASE_DOMAIN;
};

export const isForeignHost = (
	hostname: string,
	configuredBaseDomain: string | undefined
): boolean => {
	const estateBaseDomain = getEstateBaseDomain(configuredBaseDomain);
	const normalizedHost = normalizeDomain(hostname);

	if (normalizedHost === estateBaseDomain) {
		return false;
	}

	const estateHostSuffix = `.${estateBaseDomain}`;
	if (normalizedHost.endsWith(estateHostSuffix)) {
		const prefix = normalizedHost.slice(0, -estateHostSuffix.length);
		return prefix.includes(".");
	}

	return true;
};

export const buildCampaignIdentifier = ({
	campaignId,
	subdomain,
	hostname,
	estateBaseDomain,
}: CampaignIdentifierOptions): InitialCampaignSource => {
	if (campaignId) {
		return { campaignId, subdomain: null };
	}

	if (isForeignHost(hostname, estateBaseDomain)) {
		return {
			campaignId: null,
			subdomain: null,
			host: hostname,
		};
	}

	return {
		campaignId: null,
		subdomain,
	};
};

export const buildInitialCampaignRequestPayload = (
	campaignSource: InitialCampaignSource
): Record<string, string> => {
	if (campaignSource.campaignId) {
		return { campaignId: campaignSource.campaignId };
	}

	if (campaignSource.host) {
		return { host: campaignSource.host };
	}

	if (campaignSource.subdomain) {
		return { subdomain: campaignSource.subdomain };
	}

	return {};
};
